import { MessageCircle } from "lucide-react";
import { useLang, CONTACT } from "@/lib/i18n";

export default function WhatsAppFloat() {
  const { t } = useLang();
  const href = `${CONTACT.whatsappLink}?text=${encodeURIComponent(t.wa_prefill)}`;
  return (
    <a href={href} target="_blank" rel="noreferrer" aria-label={t.cta_whatsapp} data-testid="whatsapp-float-btn"
      className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-3 rounded-full bg-[#25D366] text-[#050B14] shadow-[0_10px_30px_rgba(37,211,102,0.35)] pl-4 pr-4 sm:pr-5 py-4 hover:-translate-y-1 hover:bg-[#3be37a] transition-[transform,background-color] duration-300">
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping [animation-duration:2.5s] -z-10" />
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline text-sm font-medium tracking-wide">WhatsApp</span>
    </a>
  );
}
